import React, { useEffect, useState } from "react";
import "../App.scss";

type ProgressBarProps = {
    label: string;
    progress?: number; // progress is now the maximum number of blocks
    error?: boolean;
};

export default function ProgressBar({ label, progress = 20, error }: ProgressBarProps) {
    const totalBlocks = progress; // set maximum blocks to progress
    const [filledBlocks, setFilledBlocks] = useState(1);
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        if (filledBlocks < totalBlocks) {
            const timer = setTimeout(() => {
                setFilledBlocks(filledBlocks + 1);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [filledBlocks, totalBlocks]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setSeconds(seconds + 1);
        }, 1000);
        return () => clearTimeout(timer);
    }, [seconds, filledBlocks, totalBlocks]);

    const emptyBlocks = totalBlocks - filledBlocks;
    const safeFilledBlocks = Math.max(0, filledBlocks);
    const safeEmptyBlocks = Math.max(0, emptyBlocks);
    const bar =
        `[ ${label} ` +
        ".".repeat(safeFilledBlocks) +
        " ".repeat(safeEmptyBlocks) +
        `${seconds}s` +
        `]`;

    return (
        <div className="progressbar-container">
            <pre className="progressbar-text">
                { 
                    error ? 
                        `[ Uh oh ... ${label} ... ]`
                    :
                        bar
                }
            </pre>
        </div>
    );
}
